export default __webpack_public_path__ + "static/logo-bfsp-e8dcbba1d65a04ebfd10f86467128b7b.png";